
export default {
  tip: {
    timeSort: '按更新时间排序',
    rewardSort: '按奖励金额排序'
  },
  label: {
    location: '工作地点',
    jobType: '工作类型',
    salary: '月薪',
    workTime: '工作时间',
    roleType: '工作性质'
  },
  location: {
    city: '城市',
    region: '区域',
    area: '商圈',
    currentCity: '定位',
    yourLocation: '您可能在',
    noLocation: '我们暂时无法获取到您的位置，请从列表中选取。',
    hotCities: '热门城市',
    allCities: '全部城市',
    allRegions: '全部地区',
    allAreas: '全部商圈'
  },
  jobType: {
    industry: '行业',
    type: '工种',
    allIndustries: '全部行业',
    allTypes: '全部工种'
  },
  roleType: {
    fullTime: '全职',
    partTime: '兼职',
    intern: '实习'
  },
  btn: {
    confirm: '确认'
  }
}
